/* Royal PDP vanilla JS interactions */
(function () {
  'use strict';

  function cartAddUrl() {
    return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
  }

  function cartDrawerUrl() {
    return ((window.routes && window.routes.cart_url) || '/cart') + '?section_id=cart-drawer';
  }

  function addItemsToCart(items) {
    var body = { items: items };

    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    });
  }

  function renderCartUpdate(data) {
    var drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.openAfterAdd === 'function') {
      drawer.openAfterAdd(data || {});
      return;
    }

    if (drawer && data && data.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
      return;
    }

    refreshCartDrawer();
  }

  function prepareCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.prepareForAdd === 'function') {
      drawer.prepareForAdd(document.activeElement);
    }
  }

  function markCartAddFailed(message) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.markAddFailed === 'function') {
      drawer.markAddFailed(message || 'Unable to add this item. Please try again.');
    }
  }

  function normalizeApprovedPdpCopy(pdp) {
    var walkKitHeading = pdp.querySelector('.wo-walkkit__heading');
    var walkKitItems = pdp.querySelector('.wo-walkkit__items');
    if (walkKitHeading && walkKitHeading.textContent.trim() === 'Make It A Walk Kit') {
      walkKitHeading.textContent = 'Complete The Matching Walk Kit';
      if (walkKitItems) {
        walkKitItems.setAttribute('aria-label', 'Complete The Matching Walk Kit');
      }
    }

    if (!pdp.querySelector('.wo-style-note')) {
      var title = pdp.querySelector('.wo-info .wo-title');
      if (title && title.textContent.indexOf('Harness') !== -1) {
        var note = document.createElement('p');
        note.className = 'wo-style-note';
        note.textContent = 'Start the matching walk look with a secure harness made to style with the full set.';
        title.insertAdjacentElement('afterend', note);
      }
    }
  }

  /* ── Gallery ─────────────────────────────────────────────── */
  function initGallery(pdp) {
    var gallery  = pdp.querySelector('[data-wo-gallery]');
    if (!gallery) return;

    var imgs     = Array.prototype.slice.call(gallery.querySelectorAll('[data-wo-img]'));
    var thumbs   = Array.prototype.slice.call(gallery.querySelectorAll('[data-wo-thumb]'));
    var sizeCaptions = Array.prototype.slice.call(gallery.querySelectorAll('[data-wo-size-caption]'));
    var counter  = gallery.querySelector('[data-wo-counter]');
    var btnPrev  = gallery.querySelector('[data-wo-prev]');
    var btnNext  = gallery.querySelector('[data-wo-next]');
    var btnExp   = gallery.querySelector('[data-wo-expand]');
    var lightbox = document.querySelector('[data-wo-lightbox]');
    var lbImg    = lightbox && lightbox.querySelector('[data-wo-lightbox-img]');
    var lbClose  = lightbox && lightbox.querySelector('[data-wo-lightbox-close]');
    var total    = imgs.length;
    var current  = 0;
    var didSwipe = false;

    function goTo(index) {
      current = (index + total) % total;
      imgs.forEach(function (img, i) {
        img.classList.toggle('is-active', i === current);
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-wo-thumb'), 10) === current);
      });
      sizeCaptions.forEach(function (caption) {
        caption.classList.toggle('is-active', parseInt(caption.getAttribute('data-wo-size-caption'), 10) === current);
      });
      if (counter) counter.textContent = (current + 1) + ' / ' + total;
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.getAttribute('data-wo-thumb'), 10));
      });
    });
    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); });

    /* Swipe support */
    var startX = 0;
    var frame  = gallery.querySelector('[data-wo-frame]');
    if (frame) {
      frame.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      frame.addEventListener('touchend',   function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) {
          didSwipe = true;
          goTo(dx < 0 ? current + 1 : current - 1);
          setTimeout(function () { didSwipe = false; }, 350);
        }
      });
      frame.addEventListener('click', function (e) {
        if (window.matchMedia && !window.matchMedia('(max-width: 767px)').matches) return;
        if (didSwipe || !e.target || !e.target.matches('[data-wo-img]')) return;
        openLightbox();
      });
    }

    /* Lightbox */
    if (btnExp && lightbox && lbImg) {
      btnExp.addEventListener('click', openLightbox);
    }
    if (lbClose && lightbox) {
      lbClose.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
    function openLightbox() {
      if (!lightbox || !lbImg) return;
      var activeImg = gallery.querySelector('[data-wo-img].is-active');
      if (activeImg) {
        lbImg.src = activeImg.getAttribute('data-wo-full-src') || activeImg.currentSrc || activeImg.src;
        lbImg.alt = activeImg.getAttribute('alt') || '';
      }
      lightbox.classList.add('is-open');
      document.body.classList.add('wo-lightbox-open');
      document.body.style.overflow = 'hidden';
      if (lbClose) lbClose.focus();
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      document.body.classList.remove('wo-lightbox-open');
      document.body.style.overflow = '';
    }

    goTo(current);
  }

  /* ── Variant picker ──────────────────────────────────────── */
  function initVariantPicker(pdp) {
    var varSel   = pdp.querySelector('[data-wo-variant-select]');
    var priceEls = Array.prototype.slice.call(pdp.querySelectorAll('[data-wo-price]'));
    var compareEls = Array.prototype.slice.call(pdp.querySelectorAll('[data-wo-compare]'));
    var saveEls = Array.prototype.slice.call(pdp.querySelectorAll('[data-wo-save]'));
    var atcBtns = Array.prototype.slice.call(pdp.querySelectorAll('[data-wo-atc]'));
    var atcTexts = Array.prototype.slice.call(pdp.querySelectorAll('[data-wo-atc-text]'));
    var afterpayTriggers = Array.prototype.slice.call(pdp.querySelectorAll('[data-wo-afterpay-checkout]'));
    var afterpayPlacements = Array.prototype.slice.call(pdp.querySelectorAll('afterpay-placement'));
    var afterpayInstallments = Array.prototype.slice.call(pdp.querySelectorAll('[data-wo-afterpay-installment]'));
    var errorEl  = pdp.querySelector('[data-wo-error]');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function getSelected() {
      var vals = ['', '', ''];
      pdp.querySelectorAll('[data-wo-opt-btn].is-active').forEach(function (btn) {
        var pos = parseInt(btn.getAttribute('data-wo-opt-btn'), 10);
        vals[pos - 1] = btn.getAttribute('data-wo-opt-value');
      });
      pdp.querySelectorAll('[data-wo-opt-select]').forEach(function (sel) {
        var pos = parseInt(sel.getAttribute('data-wo-opt-select'), 10);
        vals[pos - 1] = sel.value;
      });
      return vals;
    }

    function updateVariant() {
      if (!varSel) return;
      var vals  = getSelected();
      var sizeSelect = pdp.querySelector('.wo-size-select');
      if (pdp.hasAttribute('data-rc-require-size') && sizeSelect && !sizeSelect.value) {
        varSel.value = '';
        atcBtns.concat(afterpayTriggers).forEach(function (button) { button.disabled = true; });
        atcTexts.forEach(function (label) { label.textContent = 'Choose a size'; });
        return;
      }
      var match = null;
      Array.prototype.slice.call(varSel.options).forEach(function (opt) {
        if (match || !opt.value) return;
        var parts = (opt.getAttribute('data-opts') || '').split('|');
        var ok    = true;
        for (var i = 0; i < 3; i++) {
          if (vals[i] && parts[i] !== vals[i]) { ok = false; break; }
        }
        if (ok) match = opt;
      });
      if (!match) { varSel.value = ''; atcBtns.concat(afterpayTriggers).forEach(function (b) { b.disabled = true; }); return; }
      varSel.value = match.value;

      var priceCents   = parseInt(match.getAttribute('data-price-cents'), 10) || 0;
      var compareCents = parseInt(match.getAttribute('data-compare-cents'), 10) || 0;
      var available    = match.getAttribute('data-available') === 'true';

      priceEls.forEach(function (priceEl) {
        priceEl.textContent = match.getAttribute('data-price') || formatMoney(priceCents);
      });
      if (compareCents > priceCents) {
        compareEls.forEach(function (compareEl) {
          compareEl.textContent = formatMoney(compareCents);
          compareEl.hidden = false;
        });
        saveEls.forEach(function (saveEl) {
          saveEl.textContent = 'Save ' + formatMoney(compareCents - priceCents).replace(/\.00$/, '');
          saveEl.hidden = false;
        });
      } else {
        compareEls.forEach(function (compareEl) { compareEl.hidden = true; });
        saveEls.forEach(function (saveEl) { saveEl.hidden = true; });
      }
      atcBtns.forEach(function (atcBtn) { atcBtn.disabled = !available; });
      afterpayTriggers.forEach(function (afterpayTrigger) { afterpayTrigger.disabled = !available; });
      atcTexts.forEach(function (atcText) {
        atcText.textContent = available
          ? atcText.getAttribute('data-available-text') || 'Add to Cart'
          : atcText.getAttribute('data-sold-out-text') || 'Sold Out';
      });
      afterpayPlacements.forEach(function (placement) {
        placement.setAttribute('data-amount', (priceCents / 100).toFixed(2));
      });
      afterpayInstallments.forEach(function (installment) {
        installment.textContent = formatMoney(Math.round(priceCents / 4));
      });
    }

    pdp.querySelectorAll('[data-wo-opt-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-wo-opt-btn');
        var value = btn.getAttribute('data-wo-opt-value');
        pdp.querySelectorAll('[data-wo-opt-btn="' + pos + '"]').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
        pdp.querySelectorAll('[data-wo-opt-select="' + pos + '"]').forEach(function (sel) { sel.value = value; });
        var label = pdp.querySelector('[data-wo-opt-val="' + pos + '"]');
        if (label) label.textContent = value;
        updateVariant();
      });
    });

    pdp.querySelectorAll('[data-wo-opt-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var pos = sel.getAttribute('data-wo-opt-select');
        pdp.querySelectorAll('[data-wo-opt-btn="' + pos + '"]').forEach(function (btn) {
          btn.classList.toggle('is-active', btn.getAttribute('data-wo-opt-value') === sel.value);
          btn.setAttribute('aria-pressed', String(btn.getAttribute('data-wo-opt-value') === sel.value));
        });
        var label = pdp.querySelector('[data-wo-opt-val="' + pos + '"]');
        if (label) label.textContent = sel.value;
        updateVariant();
      });
    });
  }

  /* ── Quantity stepper ────────────────────────────────────── */
  function initQty(pdp) {
    var qtyInput = pdp.querySelector('[data-wo-qty-input]');
    if (!qtyInput) return;
    pdp.querySelectorAll('[data-wo-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-wo-qty'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
      });
    });
  }

  /* ── Afterpay checkout link ─────────────────────────────── */
  function initAfterpayCheckout(pdp) {
    var trigger = pdp.querySelector('[data-wo-afterpay-checkout]');
    var form = pdp.querySelector('form[data-type="add-to-cart-form"]');
    var productForm = pdp.querySelector('product-form');
    var didPrewarmCheckout = false;
    if (!trigger || !form) return;

    function setLoading(isLoading) {
      trigger.disabled = isLoading;
      trigger.classList.toggle('is-loading', isLoading);
      trigger.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function prewarmCheckout() {
      if (didPrewarmCheckout) return;
      didPrewarmCheckout = true;

      ['preconnect', 'prefetch'].forEach(function (rel) {
        var link = document.createElement('link');
        link.rel = rel;
        link.href = '/checkout';
        document.head.appendChild(link);
      });
    }

    trigger.addEventListener('pointerenter', prewarmCheckout, { once: true });
    trigger.addEventListener('touchstart', prewarmCheckout, { once: true, passive: true });

    trigger.addEventListener('click', function () {
      if (trigger.disabled) return;
      prewarmCheckout();

      var formData = new FormData(form);
      var variantId = parseInt(formData.get('id'), 10);
      var quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
      var hasIncludedStorageBag = productForm && productForm.dataset.includedStorageBag === 'true';
      var bundleItems = productForm && typeof productForm.getBundleComponentItems === 'function'
        ? productForm.getBundleComponentItems(variantId, quantity)
        : [];
      var bundleProperties = productForm && typeof productForm.getBundleParentProperties === 'function'
        ? productForm.getBundleParentProperties(bundleItems)
        : null;
      var cartAddUrl = `${routes.cart_add_url}`.indexOf('.js') === -1
        ? `${routes.cart_add_url}.js`
        : `${routes.cart_add_url}`;
      var parentItem = { id: variantId, quantity: quantity };
      if (bundleProperties || hasIncludedStorageBag) {
        parentItem.properties = Object.assign({}, bundleProperties || {}, hasIncludedStorageBag
          ? { Includes: 'Complimentary cotton storage bag — valued at $19' }
          : {});
      }
      var items = [parentItem];

      if (!variantId) return;
      setLoading(true);

      fetch(cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to start Afterpay checkout.');
          window.location.assign('/checkout');
        })
        .catch(function () {
          setLoading(false);
          var errorEl = pdp.querySelector('[data-wo-error]');
          if (errorEl) {
            errorEl.textContent = 'Afterpay checkout could not start. Please try again.';
            errorEl.hidden = false;
          }
        });
    });
  }

  /* ── Walk Kit add buttons ────────────────────────────────── */
  function initWalkKit(pdp) {
    pdp.querySelectorAll('[data-wo-kit-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var textEl = btn.querySelector('[data-wo-kit-add-text]');
        var orig   = textEl ? textEl.textContent : 'Add';
        btn.disabled = true;
        if (textEl) textEl.textContent = 'Adding…';
        prepareCartDrawer();
        addItemsToCart([{ id: parseInt(variantId, 10), quantity: 1 }])
          .then(function (res) {
            if (!res.ok) { markCartAddFailed(res.data && (res.data.description || res.data.message)); btn.disabled = false; if (textEl) textEl.textContent = orig; return; }
            if (textEl) textEl.textContent = 'Added!';
            renderCartUpdate(res.data);
            setTimeout(function () { btn.disabled = false; if (textEl) textEl.textContent = orig; }, 1400);
          })
          .catch(function () { markCartAddFailed(); btn.disabled = false; if (textEl) textEl.textContent = orig; });
      });
    });
  }

  /* Favorites add buttons used in the Royal More Favorites section. */
  function initFavCards() {
    document.querySelectorAll('[data-wo-fav-add]').forEach(function (btn) {
      if (btn._woInit) return;
      btn._woInit = true;
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var orig = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        prepareCartDrawer();
        addItemsToCart([{ id: parseInt(variantId, 10), quantity: 1 }])
          .then(function (res) {
            if (!res.ok) { markCartAddFailed(res.data && (res.data.description || res.data.message)); btn.disabled = false; btn.innerHTML = orig; return; }
            btn.textContent = 'Added!';
            renderCartUpdate(res.data);
            setTimeout(function () { btn.disabled = false; btn.innerHTML = orig; }, 1400);
          })
          .catch(function () { markCartAddFailed(); btn.disabled = false; btn.innerHTML = orig; });
      });
    });
  }

  /* ── Reviews scroll target ───────────────────────────────── */
  function initReviewScroll(pdp) {
    var buttons = Array.prototype.slice.call(pdp.querySelectorAll('[data-wo-scroll-reviews]'));
    if (!buttons.length) return;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById('wo-reviews');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  /* ── Size chart modal ───────────────────────────────────── */
  function initSizeChart(pdp) {
    var modal = document.querySelector('[data-wo-size-chart-modal]');
    var openBtns = Array.prototype.slice.call(pdp.querySelectorAll('[data-wo-size-chart-open]'));
    if (!modal || !openBtns.length) return;

    var closeBtns = Array.prototype.slice.call(modal.querySelectorAll('[data-wo-size-chart-close]'));
    var lastFocus = null;
    var scrollY = 0;

    function openModal() {
      lastFocus = document.activeElement;
      scrollY = window.scrollY || window.pageYOffset || 0;
      modal.hidden = false;
      document.documentElement.classList.add('wo-size-chart-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-wo-size-chart-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.classList.remove('wo-size-chart-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.hidden && e.key === 'Escape') closeModal();
    });
  }

  /* ── Free gift info modal ───────────────────────────────── */
  function initFreeGiftInfo(pdp) {
    var modal = document.querySelector('[data-wo-free-gift-modal]');
    var openBtns = Array.prototype.slice.call(pdp.querySelectorAll('[data-wo-free-gift-open]'));
    if (!modal || !openBtns.length) return;

    var closeBtns = Array.prototype.slice.call(modal.querySelectorAll('[data-wo-free-gift-close]'));
    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';

      var closeBtn = modal.querySelector('[data-wo-free-gift-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';

      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    openBtns.forEach(function (openBtn) {
      openBtn.addEventListener('click', openModal);
    });
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.hidden && e.key === 'Escape') closeModal();
    });
  }

  /* ── PDP size help jump ─────────────────────────────────── */
  function initSizeHelpLinks() {
    document.querySelectorAll('[data-wo-size-help-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById('wo-tab-size');
        if (!target) return;
        event.preventDefault();

        var tabs = target.closest('[data-wo-features-tabs]');
        if (tabs) {
          tabs.querySelectorAll('[data-wo-tab-btn]').forEach(function (btn) {
            var isSize = btn.getAttribute('data-wo-tab-btn') === 'size';
            btn.classList.toggle('is-active', isSize);
            btn.setAttribute('aria-selected', isSize ? 'true' : 'false');
          });
          tabs.querySelectorAll('[data-wo-tab-panel]').forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-wo-tab-panel') === 'size');
          });
        }

        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Features-Tabs (full-width section) ─────────────────── */
  function initFeaturesTabs() {
    document.querySelectorAll('[data-wo-features-tabs]').forEach(function (section) {
      section.querySelectorAll('[data-wo-tab-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-wo-tab-btn');
          section.querySelectorAll('[data-wo-tab-btn]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
          });
          section.querySelectorAll('[data-wo-tab-panel]').forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-wo-tab-panel') === target);
          });
        });
      });
    });
  }

  /* ── Newsletter form ─────────────────────────────────────── */
  function initNewsletter() {
    document.querySelectorAll('[data-wo-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('[data-wo-email]');
        if (!email || !email.value) return;
        var submitBtn = form.querySelector('[data-wo-subscribe]');
        var orig = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) submitBtn.textContent = '✓';
        setTimeout(function () {
          if (submitBtn) submitBtn.textContent = orig;
          if (email) email.value = '';
        }, 2000);
      });
    });
  }

  /* ── Cart drawer refresh ─────────────────────────────────── */
  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    fetch(cartDrawerUrl())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          if (typeof drawer.open === 'function') drawer.open();
        }
      });
  }

  /* ── Boot ────────────────────────────────────────────────── */
  function boot() {
    var pdp = document.querySelector('[data-wo-pdp]');
    if (pdp) {
      normalizeApprovedPdpCopy(pdp);
      initGallery(pdp);
      initVariantPicker(pdp);
      initQty(pdp);
      initAfterpayCheckout(pdp);
      initWalkKit(pdp);
      initReviewScroll(pdp);
      initSizeChart(pdp);
      initFreeGiftInfo(pdp);
    }
    initSizeHelpLinks();
    initFeaturesTabs();
    initFavCards();
    initNewsletter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
